import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.667 18.667h-1.053l-0.373-0.36c1.6-1.867 2.427-4.413 1.973-7.12-0.627-3.707-3.72-6.667-7.453-7.12-5.64-0.693-10.387 4.053-9.693 9.693 0.453 3.733 3.413 6.827 7.12 7.453 2.707 0.453 5.253-0.373 7.12-1.973l0.36 0.373v1.053l5.667 5.667c0.547 0.547 1.44 0.547 1.987 0s0.547-1.44 0-1.987l-5.653-5.68zM12.667 18.667c-3.32 0-6-2.68-6-6s2.68-6 6-6 6 2.68 6 6-2.68 6-6 6z" })
});
export default SvgSearch;
